import { render } from "./DashboardWidget.vue?vue&type=template&id=1668db66&scoped=true"
import script from "./DashboardWidget.vue?vue&type=script&lang=js"
export * from "./DashboardWidget.vue?vue&type=script&lang=js"

import "./DashboardWidget.vue?vue&type=style&index=0&id=1668db66&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1709076162/src/harpia-offshore-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1668db66"]])

export default __exports__